
import { Component, Vue } from 'vue-property-decorator';
import { OAClientsCollection } from '@/collections/OAClients';
import { OAClientModel } from '@/models/OAClient';

@Component
export default class OAClients extends Vue {
  public isLoading: boolean = true;
  public oaClients: OAClientsCollection = new OAClientsCollection();

  public headers = [
    { text: 'Name', value: 'name', sortable: true },
    { text: 'Client ID', value: 'clientId', sortable: false },
    { text: 'Redirect URIs', value: 'redirectUris', sortable: false, width: '40%' },
    { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
  ];

  public async created() {
    this.isLoading = true;
    await this.oaClients.fetch();
    this.isLoading = false;
  }

  public editClient(clientId: string) {
    this.$router.push(`/oa_clients/edit/${clientId}`);
  }
}
